import { Button, ButtonProps } from '@chakra-ui/react';
import { AddIcon } from 'lib/icons/add';
import { FC } from 'react';

export const ButtonAdd: FC<ButtonProps> = ({ children, className, ...rest }) => (
  <Button variant="secondary" size="sm" {...rest}>
    <AddIcon marginRight="6px" /> { children }
  </Button>
);
